(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tapin-back"] && !Shopify.designMode) return;
  try {
    const tapinBack = document.getElementById('tapin-back-link');
  if (tapinBack && document.referrer) {
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === window.location.origin && previous.pathname !== window.location.pathname) {
        tapinBack.href = previous.href;
        tapinBack.addEventListener('click', (event) => {
          if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && window.history.length > 1) {
            event.preventDefault();
            window.history.back();
          }
        });
      }
    } catch {}
  }
  } catch(e) { console.error(e); }
})();

})();
